module.exports = __webpack_public_path__ + "79bf35c5abffe10479430a1d62b5917e.svg";